<template>
  <v-container pa-0 ma-0 fluid>
    <div class="section_inner mt-6">
      <div class="banner-wrap">
        <Banner class="pc-banner" :is-hitech="false" />
      </div>
      <v-row class="mt-7">
        <v-col cols="12" md="9">
          <v-row class="justify-center">
            <v-col class="pt-0" cols="12">
              <h1 class="display-2 primary--text mt-0 mb-5 text-center">
                <v-icon
                  color="primary--text"
                  class="display-36 primary--text px-2"
                >
                  icon-user
                </v-icon>
                איפוס סיסמה
              </h1>
              <DropDivider :width="'90%'" />
            </v-col>

            <v-col cols="10" sm="4">
              <v-form
                id="reset=password"
                ref="form"
                v-model="valid"
                class="rtl pa-0 mt-2"
                @keydown.enter="validate"
                v-if="!formSent"
              >
                <PasswordField
                  @newPassword="applyPassword"
                  :showRecoverLink="false"
                  v-model="newPassword"
                />
                <RememberMe v-model="rememberMe" @checked="applyRememberMe" />

                <v-col class="text-center">
                  <v-btn
                    :disabled="!valid"
                    class="orange_btn_large"
                    @click="submitForm"
                  >
                    שלח
                  </v-btn>
                  <small
                    v-if="error"
                    class="d-block red--text text-center my-2"
                  >
                    שגיאה בשליחת הפנייה
                  </small>
                </v-col>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="hidden-sm-and-down">
          <PublishJobAd />
          <SectionCompaniesInnerPages :page="'resetPWPage'" />
        </v-col>
      </v-row>
    </div>
    <ThankYouDialog
      :openDialog="dialogSuccess"
      :dialogContent="'יש! הסיסמה עודכנה בהצלחה'"
      @closeDialog="applyCloseDialog"
    />
  </v-container>
</template>

<script>
import Banner from '@/components/Jobs_List/Banner';
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';
import PublishJobAd from '@/components/Jobs_List/Ads/PublishJobAd';
import PasswordField from '@/components/Forms/Form_Fields/PasswordField';
import RememberMe from '@/components/Forms/Form_Fields/RememberMe';
import ThankYouDialog from '@/components/Dialogs/ThankYouDialog/ThankYouDialog';
import DropDivider from '@/components/DropDownMenu/DropDivider';
import { SET_PASSWORD } from '@/lib/api.js';
import recaptchaV3 from '@/components/mixins/recaptchaV3';

export default {
  mixins: [recaptchaV3],
  layout: 'innerPage',
  name: 'resetPasswrodPAge',
  components: {
    Banner,
    SectionCompaniesInnerPages,
    PublishJobAd,
    PasswordField,
    RememberMe,
    ThankYouDialog,
    DropDivider,
  },

  data() {
    return {
      valid: false,
      formSubmited: false,
      formSent: false,
      newPassword: null,
      error: false,
      passwordToken: '',
      seekerToken: '',
      rememberMe: true,
      dialogSuccess: false,
    };
  },

  mounted() {
    /**
     * get token from url
     */
    this.getToken();
  },
  methods: {
    applyPassword(val) {
      this.newPassword = val;
    },
    applyRememberMe(val) {
      this.rememberMe = val;
    },
    applyCloseDialog(val) {
      this.$router.push('/enter.aspx');
      this.dialogSuccess = false;
    },

    getToken() {
      this.passwordToken = this.$route.query.token;
    },

    async submitForm() {
      this.error = false;
      const recaptcha = await this.recaptchaCheck('resetPassword');

      if (!recaptcha) {
        throw 'ERROR => recaptcha reset page';
      }
      if (this.$refs.form.validate()) {
        const data = {
          password: this.newPassword,
          rememberMe: this.rememberMe,
        };

        this.$nuxt.$loading.start();
        try {
          await this.$axios
            .post(`${SET_PASSWORD}?token=${this.passwordToken}`, data)
            .then((response) => {
              if (response.data.IsError) {
                throw response.data.Error;
              }

              this.formSent = true;
              this.dialogSuccess = true;
              this.$nuxt.$loading.finish();
            });
        } catch (e) {
          this.$nuxt.$loading.finish();
          this.error = true;
        }
      }
    },
  },
  beforeDestroy() {},
};
</script>
